import React from 'react';
import PropTypes from 'prop-types';
import { QuantityInput } from '../';

export default class InputSpinner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.initialQuantity,
    };
  }

  changeHandler(newValue) {
    this.setState({
      value: newValue,
    });

    if (this.props.onUpdateQuantity !== undefined) { this.props.onUpdateQuantity(newValue); }
  }

  stepQuantity(packSizeStep) {
    let newValue = this.state.value;
    newValue = newValue || 0;

    const remainder = newValue % packSizeStep;

    if (remainder !== 0) {
      newValue = packSizeStep > 0
        ? Math.ceil(newValue / packSizeStep) * packSizeStep
        : Math.floor(newValue / Math.abs(packSizeStep)) * Math.abs(packSizeStep);
    } else {
      newValue += packSizeStep;
    }

    if (newValue <= 0 || newValue > this.props.maximumQuantity) { return; }

    this.changeHandler(newValue);
  }

  render() {
    return (
      <div className="input-group spinner">
        <QuantityInput
          maximumQuantity={this.props.maximumQuantity}
          onChangeHandler={newValue => this.changeHandler(newValue)}
          value={this.state.value}
          className="form-control"
        />
        <div className="input-group-btn-vertical">
          <button
            className="btn btn-default"
            type="button"
            onClick={() => this.stepQuantity(this.props.packSize)}
          >
            <i className="icon icon-rs_82-pointer-up" />
          </button>
          <button
            className="btn btn-default"
            type="button"
            onClick={() => this.stepQuantity(-this.props.packSize)}
          >
            <i className="icon icon-rs_45-pointer-down" />
          </button>
        </div>
      </div>
    );
  }
}
InputSpinner.propTypes = {
  initialQuantity: PropTypes.number.isRequired,
  packSize: PropTypes.number.isRequired,
  maximumQuantity: PropTypes.number.isRequired,
  onUpdateQuantity: PropTypes.func,
};

InputSpinner.defaultProps = {
  onUpdateQuantity: undefined,
};



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/InputSpinner/InputSpinner.js